import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivationService } from '../services/activation.service';


@Component({
    selector: 'app-activation',
    templateUrl: './crypt.component.html'
})

export class CryptComponet {

    public resCode;
    public respReq;
    public error = false;
    public resError;

    constructor(public service: ActivationService, private toastr: ToastrService, private spinner: NgxSpinnerService) {
    }

    onSubmit(form: NgForm) {
        this.spinner.show();
        this.service.requestCrypt(form.value.text).subscribe(

            res => {
                this.respReq = true;
                this.resCode = res;
                this.toastr.success('Ok', "")
                this.spinner.hide();
            },
            err => {
                this.resError = err.error;
                this.error = true;
                this.respReq = true;
                this.spinner.hide();
            }
        )
    }

    resetForm(form: NgForm) {
        this.respReq = false;
        form.resetForm();
    }


}
